export * from './ePrescription.service';
import { EPrescriptionService } from './ePrescription.service';
export const APIS = [EPrescriptionService];
